'use client';
import React from 'react';

export const waveVariants = {
  accent(props) {
    return (
      <svg
        width="1440"
        height="56"
        viewBox="0 0 1440 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_12368_61388)">
          <path
            opacity="0.06"
            d="M982 32C1048.09 32 1067.5 0 1152.48 0H816.011C883.105 0 915.907 32 982 32Z"
            fill="white"
          />
          <path
            opacity="0.24"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1708 0C1597 0 1596.5 56 1511 56C1479.08 56 1247.13 56 1151 56C1054.86 56 1037.61 0 908 0C778.39 0 1678.71 0 1708 0Z"
            fill="#1A1A1A"
          />
          <g opacity="0.4" filter="url(#filter0_f_12368_61388)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M178.357 0C52.3497 5.58649 20.2232 37.7143 -17.3403 37.7143C-54.9037 37.7143 -93.9329 0 -121 0C-121 0 131.9 0 178.357 0Z"
              fill="#D6D600"
            />
          </g>
          <g opacity="0.48" filter="url(#filter1_f_12368_61388)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M261.643 0C143.432 5.82271 120.977 51.8571 75.9356 49.5C30.8939 47.1429 14.5575 0 -33 0C-33 0 218.06 0 261.643 0Z"
              fill="#B21A57"
            />
          </g>
          <g opacity="0.48" filter="url(#filter2_f_12368_61388)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M332.071 0.0940495C230.545 53.6863 106.922 23.4845 61 0.0940495H332.071Z"
              fill="#0557D5"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_f_12368_61388"
            x="-169"
            y="-48"
            width="395.357"
            height="133.714"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_12368_61388" />
          </filter>
          <filter
            id="filter1_f_12368_61388"
            x="-81"
            y="-48"
            width="390.643"
            height="145.587"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_12368_61388" />
          </filter>
          <filter
            id="filter2_f_12368_61388"
            x="13"
            y="-47.9058"
            width="367.071"
            height="125.906"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_12368_61388" />
          </filter>
          <clipPath id="clip0_12368_61388">
            <rect width="1440" height="56" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  brand(props) {
    return (
      <svg
        width="1440"
        height="56"
        viewBox="0 0 1440 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_12368_49156)">
          <path
            opacity="0.06"
            d="M982 32C1048.09 32 1067.5 0 1152.48 0H816.011C883.105 0 915.907 32 982 32Z"
            fill="white"
          />
          <path
            opacity="0.24"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1708 0C1597 0 1596.5 56 1511 56C1479.08 56 1247.13 56 1151 56C1054.86 56 1037.61 0 908 0C778.39 0 1678.71 0 1708 0Z"
            fill="#0D0D0D"
          />
          <g opacity="0.4" filter="url(#filter0_f_12368_49156)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M178.357 0C52.3497 5.58649 20.2232 37.7143 -17.3403 37.7143C-54.9037 37.7143 -93.9329 0 -121 0C-121 0 131.9 0 178.357 0Z"
              fill="#04FB2C"
            />
          </g>
          <g opacity="0.48" filter="url(#filter1_f_12368_49156)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M261.643 0C143.432 5.82271 120.977 51.8571 75.9356 49.5C30.8939 47.1429 14.5575 0 -33 0C-33 0 218.06 0 261.643 0Z"
              fill="#0557D5"
            />
          </g>
          <g opacity="0.48" filter="url(#filter2_f_12368_49156)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M332.071 0.0940495C230.545 53.6863 106.922 23.4845 61 0.0940495H332.071Z"
              fill="#B21A57"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_f_12368_49156"
            x="-169"
            y="-48"
            width="395.357"
            height="133.714"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_12368_49156" />
          </filter>
          <filter
            id="filter1_f_12368_49156"
            x="-81"
            y="-48"
            width="390.643"
            height="145.587"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_12368_49156" />
          </filter>
          <filter
            id="filter2_f_12368_49156"
            x="13"
            y="-47.9058"
            width="367.071"
            height="125.906"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_12368_49156" />
          </filter>
          <clipPath id="clip0_12368_49156">
            <rect width="1440" height="56" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  classic(props) {
    return (
      <svg
        width="112"
        height="56"
        viewBox="0 0 112 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_12368_52589)">
          <path
            opacity="0.56"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-18 0C4.57037 0 47.9262 0 112.067 0C97.3558 11.4489 81 14.7822 63 10C37.9099 3.33413 25.1638 -1.30978 -0.00466919 4.36824C-10.1289 6.65226 -18 0 -18 0Z"
            fill="#9E54B0"
          />
          <path
            opacity="0.48"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M90 0.000125885C46.9281 22.7362 -5.51773 9.92336 -25 0.000125885H90Z"
            fill="#DF216D"
          />
          <path
            opacity="0.48"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M73 0C22.8499 2.47024 13.3237 22 -5.7849 21C-24.8935 20 -31.8241 0 -52 0C-52 0 54.5103 0 73 0Z"
            fill="#0768FD"
          />
          <path
            opacity="0.4"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M54.5991 0C1.14141 2.37003 -12.488 16 -28.424 16C-44.36 16 -60.9179 0 -72.4009 0C-72.4009 0 34.89 0 54.5991 0Z"
            fill="#00C221"
          />
        </g>
        <defs>
          <clipPath id="clip0_12368_52589">
            <rect width="112" height="56" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  inverse(props) {
    return (
      <svg
        width="1440"
        height="56"
        viewBox="0 0 1440 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_12368_52399)">
          <path
            opacity="0.06"
            d="M982 32C1048.09 32 1067.5 0 1152.48 0H816.011C883.105 0 915.907 32 982 32Z"
            fill="#0557D5"
          />
          <path
            opacity="0.24"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1708 0C1597 0 1596.5 56 1511 56C1479.08 56 1247.13 56 1151 56C1054.86 56 1037.61 0 908 0C778.39 0 1678.71 0 1708 0Z"
            fill="#0D0D0D"
          />
          <g opacity="0.4" filter="url(#filter0_f_12368_52399)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M178.357 0C52.3497 5.58649 20.2232 37.7143 -17.3403 37.7143C-54.9037 37.7143 -93.9329 0 -121 0C-121 0 131.9 0 178.357 0Z"
              fill="#04FB2C"
              fillOpacity="0.32"
            />
          </g>
          <g opacity="0.48" filter="url(#filter1_f_12368_52399)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M261.643 0C143.432 5.82271 120.977 51.8571 75.9356 49.5C30.8939 47.1429 14.5575 0 -33 0C-33 0 218.06 0 261.643 0Z"
              fill="#013D98"
            />
          </g>
          <g opacity="0.48" filter="url(#filter2_f_12368_52399)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M332.071 0.0940495C230.545 53.6863 106.922 23.4845 61 0.0940495H332.071Z"
              fill="#861341"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_f_12368_52399"
            x="-169"
            y="-48"
            width="395.357"
            height="133.714"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_12368_52399" />
          </filter>
          <filter
            id="filter1_f_12368_52399"
            x="-81"
            y="-48"
            width="390.643"
            height="145.587"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_12368_52399" />
          </filter>
          <filter
            id="filter2_f_12368_52399"
            x="13"
            y="-47.9058"
            width="367.071"
            height="125.906"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_12368_52399" />
          </filter>
          <clipPath id="clip0_12368_52399">
            <rect width="1440" height="56" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
  neutral(props) {
    return (
      <svg
        width="1440"
        height="56"
        viewBox="0 0 1440 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g clipPath="url(#clip0_12368_52303)">
          <path
            opacity="0.06"
            d="M982 32C1048.09 32 1067.5 0 1152.48 0H816.011C883.105 0 915.907 32 982 32Z"
            fill="#0557D5"
          />
          <path
            opacity="0.24"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1708 0C1597 0 1596.5 56 1511 56C1479.08 56 1247.13 56 1151 56C1054.86 56 1037.61 0 908 0C778.39 0 1678.71 0 1708 0Z"
            fill="#BFBFBF"
          />
          <g opacity="0.4" filter="url(#filter0_f_12368_52303)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M178.357 0C52.3497 5.58649 20.2232 37.7143 -17.3403 37.7143C-54.9037 37.7143 -93.9329 0 -121 0C-121 0 131.9 0 178.357 0Z"
              fill="#D6D600"
              fillOpacity="0.32"
            />
          </g>
          <g opacity="0.48" filter="url(#filter1_f_12368_52303)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M261.643 0C143.432 5.82271 120.977 51.8571 75.9356 49.5C30.8939 47.1429 14.5575 0 -33 0C-33 0 218.06 0 261.643 0Z"
              fill="#B3D1FF"
            />
          </g>
          <g opacity="0.48" filter="url(#filter2_f_12368_52303)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M332.071 0.0940495C230.545 53.6863 106.922 23.4845 61 0.0940495H332.071Z"
              fill="#F5BCD3"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_f_12368_52303"
            x="-169"
            y="-48"
            width="395.357"
            height="133.714"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_12368_52303" />
          </filter>
          <filter
            id="filter1_f_12368_52303"
            x="-81"
            y="-48"
            width="390.643"
            height="145.587"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_12368_52303" />
          </filter>
          <filter
            id="filter2_f_12368_52303"
            x="13"
            y="-47.9058"
            width="367.071"
            height="125.906"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
            <feGaussianBlur stdDeviation="24" result="effect1_foregroundBlur_12368_52303" />
          </filter>
          <clipPath id="clip0_12368_52303">
            <rect width="1440" height="56" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
};

export const ApolloWaves = ({ variant, ...rest }) => {
  const Waves = waveVariants[variant];
  return <Waves {...rest} />;
};

export default ApolloWaves;
